import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const mealie = defineConnector({
  identifier: "mealie",
  name: "Mealie",
  tagLine: "Self-hosted recipe manager and meal planner",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Enter your Mealie server URL",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://mealie.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Mealie instance.",
        },
      ],
    },
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Mealie, go to your **user profile → API Tokens** and create a new token.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/users/self`,
  },
});
